import { useCallback } from 'react';
import { useAlert } from '@trinity/chat-components/components/Modal/Alert.js';
import { useDeleteTagMutation } from './hooks/useDeleteTagMutation';

type Props = {
  tagId: number;
} & IProjectId;

export const useDeleteTagModal = (props: Props) => {
  const mutation = useDeleteTagMutation();

  const [toggleDeleteAlert, DeleteAlert] = useAlert();

  const onDeleteClick = useCallback(() => {
    mutation.mutate({
      tagId: props.tagId,
      projectId: props.projectId,
    });
  }, [
    mutation,
    props.projectId,
    props.tagId,
  ]);

  const DeleteTagModal = useCallback(() => {
    return (
      <DeleteAlert
        message={copy.message}
        onConfirm={onDeleteClick} />
    );
  }, [
    DeleteAlert,
    onDeleteClick,
  ]);

  return [toggleDeleteAlert, DeleteTagModal] as const;
};

const copy = {
  message: `Deleting a tag is irreversible and removes tagged data from transcripts.`,
};